import React from 'react';

export default function TarotReadingDetail({ position, card }) {
  if (!card) return null;

  const fields = [
    { key: 'love', label: 'ความรัก' },
    { key: 'work', label: 'การงาน' },
    { key: 'money', label: 'การเงิน' },
    { key: 'health', label: 'สุขภาพ' },
    { key: 'advice', label: 'คำแนะนำ' },
  ];

  return (
    <article className="tarot-reading-detail">
      <header className="tarot-reading-detail__header">
        <span className="tarot-reading-detail__symbol" aria-hidden="true">{card.symbol}</span>
        <div>
          <h3 className="tarot-reading-detail__title">
            {card.nameTh} ({card.nameEn})
          </h3>
          {position && (
            <p className="tarot-reading-detail__position">{position.labelTh}</p>
          )}
        </div>
      </header>

      <p className="tarot-reading-detail__insight">{position?.insight || card.upright}</p>

      <div className="tarot-reading-detail__grid">
        <p className="tarot-reading-detail__field">
          <strong>คำทำนายหลัก:</strong> {card.upright}
        </p>
        {fields.map(({ key, label }) => (
          <p key={key} className="tarot-reading-detail__field">
            <strong>{label}:</strong> {card[key]}
          </p>
        ))}
        <p className="tarot-reading-detail__field">
          <strong>ธาตุ / ดาว:</strong> {card.element} · {card.planet}
        </p>
        <p className="tarot-reading-detail__field">
          <strong>คีย์เวิร์ด:</strong> {card.keywords.join(', ')}
        </p>
      </div>
    </article>
  );
}
